module.exports = __webpack_public_path__ + "static/media/plntify-map.ddf9e20c.png";